<script>
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
	name: 'transaction-chart',
	extends: Line,
	mixins: [reactiveProp],
	props: ['chartId', 'options'],
	mounted() {
		if (this.chartId === 'transaction') {
			this.renderChart(this.chartData, this.options);
		}
	},
};
</script>
